<template>
    <div class="card">
        <div class="card-header">
          <h5>{{ this.$t('All Queries')}}</h5>
        </div>
        <div class="card-body row m-2 p-0">
            <div v-if="window.width >= 768" class="el-col-sm-24 teal-text">
                <div class="el-col-sm-7 inline">
                    <h6>{{$t('Date')}}</h6>
                </div>
                <div class="el-col-sm-5 inline">
                    <h6>{{$t('Average')}}</h6>
                </div>
                <div class="el-col-sm-8 inline">
                    <h6>{{$t('Details')}}</h6>
                </div>
                <div class="el-col-sm-4 inline">
                    <h6>{{$t('Actions')}}</h6>
                </div>
                <div class="el-col-sm-24">
                    <hr class="mb-1 mt-1">
                </div>
            </div>
            <div class="col-sm-12 p-2" v-for="query in historyItems.items" :key="query._id">
                <template>
                    <div v-if="window.width >= 768" class="el-col-sm-7 pt-2 inline-table">
                        {{ dateFormatter(query.query.evaluationTime) }}
                    </div>
                    <div v-else class="row">
                        <div class="col-12">{{ dateFormatter(query.query.evaluationTime) }}</div>
                    </div>

                    <div v-if="window.width >= 768" class="el-col-sm-5 inline-table">
                        <el-tooltip :content="`${$t('Average')}`"
                                    placement="bottom">
                            <status-indicator class="mr-1" :value="query && query.accumulation ? query.accumulation.fullAverage : null"
                                              :precision="1"/>
                        </el-tooltip>
                        <div v-if="query.anyAlertActive === true" class="d-inline-flex justify-content-around alert-indicator">
                          <div  class="alert-indicator-cell">
                            <i class="fa fa-2x fa-exclamation-triangle" style="vertical-align: -5px;"/>
                          </div>
                        </div>
                    </div>
                    <div v-else class="row" style="margin-top: 4px">
                        <div class="col-12">
                            <el-tooltip
                                    :content="`${$t('Average')}`"
                                    placement="bottom">
                                <status-indicator class="mr-1" :value="query && query.accumulation ? query.accumulation.fullAverage : null"
                                                  :precision="1"/>
                            </el-tooltip>
                            <div v-if="query.anyAlertActive === true" class="d-inline-flex justify-content-around alert-indicator">
                              <div  class="alert-indicator-cell">
                                <i class="fa fa-2x fa-exclamation-triangle" style="vertical-align: -5px;"/>
                              </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="window.width >= 768" class="el-col-sm-8">
                      <div v-if="!showDetails[query._id]">
                        <el-tooltip v-for="(answer, index) in query.answers.filter(q => q.type === 'slider')"
                                    :key="answer._id"
                                    :content="`${getAnswerTitle(answer.question, query)}`"
                                    placement="bottom">
                            <status-indicator class="mr-1"
                                              :value="answer.answer"
                                              :key="index"
                                              :precision="0"/>
                        </el-tooltip>
                      </div>
                        &nbsp;
                    </div>
                    <div v-else class="row" style="margin-top: 4px">
                        <div class="col-12" v-if="!showDetails[query._id]">
                            <el-tooltip v-for="(answer, index) in query.answers.filter(q => q.type === 'slider')"
                                        :key="answer._id"
                                        :content="`${getAnswerTitle(answer.question, query)}`"
                                        placement="bottom">
                                <status-indicator class="mr-1"
                                                  :value="answer.answer"
                                                  :key="index"
                                                  :precision="0"/>
                            </el-tooltip>
                        </div>
                    </div>

                    <div v-if="window.width >= 768" class="el-col-sm-4 inline-table">
                        <p-button round
                                  v-if="(query && query.accumulation ? query.accumulation.fullAverage !== null : false)"
                                  class="m-0 mr-1 btn-team-member-history" type="primary" icon size="sm"
                                  @click="click(query._id)">
                                <i v-if="showDetails[query._id] === true" class="fa fa-chevron-up"/>
                                <i v-if="showDetails[query._id] === false" class="fa fa-chevron-down"/>
                        </p-button>
                    </div>
                    <div v-else class="row" style="margin-top: 4px">
                        <div class="col-12">
                            <p-button round
                                      v-if="(query && query.accumulation ? query.accumulation.fullAverage !== null : false)"
                                      class="m-0 mr-1 btn-team-member-history" type="primary" icon size="sm"
                                      @click="click(query._id)">
                                <i v-if="showDetails[query._id] === true" class="fa fa-chevron-up"/>
                                <i v-if="showDetails[query._id] === false" class="fa fa-chevron-down"/>
                            </p-button>
                        </div>
                    </div>

                    
                    <div :class="`${window.width < 768 ? 'col-12 p-0' : 'el-col-sm-24'} pt-4 query-result-reduce-padding`"
                         v-if="showDetails && showDetails[query._id]">
                         
                      <div class="col-sm-12 p-0">
                        <card class="card-plain user-questionnaire">
                          <div v-if="query.summary">
                              <query-result v-model="query.summary"/>
                          </div>
                        </card>
                      </div>

                    </div>

                    <div v-if="(query && query.accumulation ? query.accumulation.fullAverage !== null : false)">
                      <div :class="`${window.width < 768 ? 'col-12 p-0' : 'el-col-sm-24'} reduce-hr-margin`">
                          <hr class="mb-0">
                      </div>
                    </div>
                    <div v-else>
                      <div :class="`${window.width < 768 ? 'col-12 p-0' : 'el-col-sm-24'}`">
                          <hr class="mb-0">
                      </div>
                    </div>
                    
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import { Input, DatePicker, Tooltip } from 'element-ui'
  import BasicChart from '../../Dashboard/Components/BasicChart'
  import StatusIndicator from '../../Dashboard/Components/StatusIndicator'
  import Modal from '../../Dashboard/Components/BasicModal'
  import LayoutWrapper from '../../UIComponents/LayoutWrapper'
  import { mapActions, mapState } from 'vuex'
  import isEmpty from 'lodash/isEmpty'
  import QueryResult from '../../Dashboard/Components/BasicQueryResult'

  export default {
    name: 'TeamMemberHistory',
    components: {
      StatusIndicator,
      Modal,
      LayoutWrapper,
      [Tooltip.name]: Tooltip,
      QueryResult
    },
    props: {
      isUserOwner: Boolean,
      questionnaireId: String,
      teamId: String,
      memberId: String
    },
    watch: {
      value (val) {
        if (val) {
          this.setShowDetails(val)
        }
      },
      historyStatus (val) {
        if (val === 'success') {
          this.setShowDetails(this.historyItems.items)
        }
      },
      memberId (val) {
        this.getHistory({
          questionnaireId: this.questionnaireId,
          teamId: this.teamId,
          memberId: this.memberId
        })
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      this.getHistory({
        questionnaireId: this.questionnaireId,
        teamId: this.teamId,
        memberId: this.memberId
      })
      
    },
    data () {
      return {
        showDetails: [],
        window: {
          width: 0
        }
      }
    },
    computed: {
      ...mapState('user/teams/lastQueryByUser', {
        historyItems: state => state.historyItems,
        historyStatus: state => state.historyStatus
      })
    },
    methods: {
      ...mapActions('user/teams/lastQueryByUser', ['getHistory']),
      setShowDetails (value) {
        let obj = {}
        value.forEach(val => {
          obj[val._id] = false
        })
        this.showDetails = obj
      },
      click (_id) {
        const prev = this.showDetails
        this.showDetails = Object.assign(prev, { [_id]: !prev[_id] })
      },
      handleResize () {
        this.window.width = window.innerWidth
      },
      dateFormatter: function (value) {
        return this.$options.filters.formatDate(value)
      },
      languageFormatter: function (item) {
        return this.$options.filters.languageString(item)
      },
      isEnabled: function () {
        const { title, description } = this.task
        return !isEmpty(title) && !isEmpty(description)
      },
      getAnswerTitle (questionId, query) {
        const questions = query.query.questions
        if (!questionId || !questions) return ''

        for (const question of questions) {
          if (String(questionId) === String(question._id)) {
            return this.languageFormatter(question.title)
          }
        }
      },
      checkPackage (allowedPackages) {
        return allowedPackages.includes(this.$auth.user.customer.settings.contract.packageType)
      }
    }
  }
</script>
<style lang="scss">
    .alert-indicator {
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      display: inline-block;
      min-width: 40px;
      max-width: 40px;
      height: 40px;
      line-height: 40px;
      margin: 1px 1px;
      padding: 0 15px;
      &.full-width {
        width: 100%;
      }
      &-cell {
        display: inline-block;
        padding: 0 4px;
        color: black;
        text-align: center;
        vertical-align: -5px !important;
        color: #ff0000 !important;
      }
      :last-child {
        text-align: left;
      }
    }

    .btn-team-member-history {
        height: 40px !important;
        width: 40px !important;
    }
    .inline-table {
        display: inline-table;
    }
    .no-div-break {
      display: inline;
      float: left;
    }
    .nowrap {
      white-space: nowrap;
    }
    .teal-text {
      color: #0097ae !important;
    }
    .query-result-reduce-padding {
      padding-top: 0px !important;
      padding-bottom: 20px !important;
    }
    @media (min-width: 769px) {
      .reduce-hr-margin {
        margin-top: -20px !important;
      }
    }
</style>
